import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as Settings } from "../../../assets/settings.svg";
import { ReactComponent as ProjectIcon } from "../../../assets/projects-icon.svg";
import { ReactComponent as SetupIcon } from "../../../assets/setup-icon.svg";
import { ReactComponent as IMS } from "../../../assets/ims.svg";
import UseGetUserRole from "../../../components/useGetUserRole";
import axios from "axios";
import { message } from "antd";
import { baseURL } from "../../../globalUtils/axiosConfig";

const useSidebar = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [data, setData] = useState();
  const [isSuperAdmin] = UseGetUserRole();
  const [showSettings, setShowSettings] = useState(true);
  const [attachmentBlobUrl, setAttachmentBlobUrl] = useState(null);

  useEffect(() => {
    setData(user);
    
    // Fetch attachment and create blob URL when user changes
    if (user?.attachments?.[0]?.path) {
      fetchAttachmentAndCreateBlobUrl(user.attachments[0]);
    }
  }, [user]);
  
  // Function to fetch attachment and create blob URL
  const fetchAttachmentAndCreateBlobUrl = async (attachment) => {
    try {
      // Create full URL for the attachment using the specific endpoint
      const attachmentUrl = `${baseURL}/attachments/${attachment.id}`;
      
      // Check if the combined name is too long and should be split
      const isNameTooLong = (firstName, lastName) => {
        return (firstName + " " + lastName).length > 15;
      };
      
      // Fetch the attachment
      const response = await axios({
        url: attachmentUrl,
        method: 'GET',
        responseType: 'blob',
      });
      
      // Get the mime type
      const mimeType = response.headers['content-type'] || 'application/octet-stream';
      
      // Create blob and URL
      const blob = new Blob([response.data], { type: mimeType });
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Set the blob URL in state
      setAttachmentBlobUrl(blobUrl);
    } catch (error) {
      console.error('Error fetching attachment:', error);
      message.error(`Failed to load attachment: ${error.response?.data?.message || error.message}`);
    }
  };

  const hanldeRoleLength = (role) =>
    role.length > 20 ? `${role.substring(0, 18) + " ..."}` : role;

  // Check if the combined name is too long and should be split
  const isNameTooLong = (firstName, lastName) => {
    return (firstName + " " + lastName).length > 15;
  };

  const menuItemsData = [
    {
      key: "1",
      src: attachmentBlobUrl || null,
      SvgImg: false,
      alt: "",
      firstName: data?.firstName || "",
      lastName: data?.lastName || "",
      isNameTooLong: isNameTooLong(data?.firstName || "", data?.lastName || ""),
      role: hanldeRoleLength(data?.jobTitle || ""),
      link: "/profile",
      hasSubItems: false,
      permission: true,
      hasPermission: true,
    },
    {
      key: "3",
      SvgImg: ProjectIcon,
      alt: "Project Icon",
      name: "Projects",
      // subItems: "Select Project",
      link: "/projects",
      hasSubItems: true,
      hasPermission: true,
      subItems: [
        {
          key: "project-control",
          SvgImg: Settings,
          alt: "project-Control",
          name: "project-Control",
          link: "/project/material-control",
          hasSubItems: false,
          hasPermission: true,
        },
      ],
    },
    {
      key: "4",
      SvgImg: SetupIcon,
      alt: "Project Icon",
      name: "Projects Setup",
      link: "/projects-setup",
      hasSubItems: false,
      hasPermission: user?.permissions?.project_setup?.view,
    },
    {
      key: "6",
      SvgImg: Settings,
      alt: "settings",
      name: "Settings",
      link: "/settings",
      hasSubItems: true,
      // permission: ["super_admin", "admin"],
      hasPermission: showSettings,
      subItems: [
        {
          key: "users-manager",
          SvgImg: Settings,
          alt: "Users Manager",
          name: "Users Manager",
          link: "/settings/users-manager",
          hasSubItems: false,
          hasPermission: user?.permissions?.user_manager?.view,
        },
        {
          key: "departments",
          SvgImg: Settings,
          alt: "Departments",
          name: "Departments",
          link: "/settings/departments",
          hasSubItems: false,
          hasPermission: user?.permissions?.departments?.view,
        },
        {
          key: "material-templates",
          SvgImg: Settings,
          alt: "Material Templates",
          name: "Material Templates",
          link: "/settings/material-templates",
          hasSubItems: false,
          hasPermission: user?.permissions?.material_templates?.view,
        },
        {
          key: "material-types",
          SvgImg: Settings,
          alt: "Material Type",
          name: "Material Type",
          link: "/settings/material-types",
          hasSubItems: false,
          hasPermission: user?.permissions?.material_types?.view,
        },
        {
          key: "project-statuses",
          SvgImg: Settings,
          alt: "Project Status",
          name: "Project Status",
          link: "/settings/project-statuses",
          hasSubItems: false,
          hasPermission: user?.permissions?.project_statuses?.view,
        },
        {
          key: "locations",
          SvgImg: Settings,
          alt: "Locations",
          name: "Locations",
          link: "/settings/locations",
          hasSubItems: false,
          hasPermission: user?.permissions?.locations?.view,
        },
        {
          key: "supplier",
          SvgImg: Settings,
          alt: "Suppliers",
          name: "Suppliers",
          link: "/settings/supplier",
          hasSubItems: false,
          hasPermission: user?.permissions?.supplier?.view,
        },
        {
          key: "commodity",
          SvgImg: Settings,
          alt: "Commodity",
          name: "Commodity",
          link: "/settings/commodity",
          hasSubItems: false,
          hasPermission: user?.permissions?.commodity?.view,
        },
      ],
    },
  ];

  return [menuItemsData];
};

export default useSidebar;
